import * as actions from '../../redux/actions';

import CommonService from '../../../../services/commonService';
import HeroSection from '../../common/HeroSection/HeroSection';
import KuposHelmet from '../../../common/KuposHelmet';
import React from 'react';
import ThemeFourSlider from '../common/ThemeFourSlider';
import ThemeFourTitle from '../common/ThemeFourTitle';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import getIcons from '../../functions/getIcons/getIcons';
import getSlides from '../../functions/getSlides/getSlides';

const ThemeFourDestinationScreen = props => {
	const operator = CommonService.getLocal('op') || props.home.operator;

	return (
		<div>
			<KuposHelmet />
			<HeroSection
				heroImage={getIcons('destinationBanner', operator)}
				height={'43vh'}
				marginTop="-18px"
				title={'Destinos'}
				description={'Home / Destinos'}
			/>
			<ThemeFourTitle title="Descubre nuestros destinos" />

			{operator && operator.operator_name === 'chilebus' ?
				(
					<div className='smallslider'>
						<ThemeFourSlider slides={getSlides('Destination', operator)} />
					</div>) : (
					<ThemeFourSlider slides={getSlides('Destination', operator)} />
				)
			}
		</div>
	);
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		home: state.home,
	};
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions }, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(ThemeFourDestinationScreen);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeFour/ThemeFourPages/ThemeFourDestinationScreen.js